const permissions = {
  accounts: {
    'read:own': ['*'],
  },
  drafts: {
    'create:own': ['*'],
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  contents: {
    'create:any': ['*'],
    'read:any': ['*'],
    'update:any': ['*'],
    'delete:any': ['*'],
  },
  dashboards: {
    'read:own': ['*'],
  },
  discussions: {
    'create:own': ['*'],
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  files: {
    'read:own': ['*'],
  },
  activities: {
    'create:own': ['*'],
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  automations: {
    'read:own': ['*'],
  },
  timelines: {
    'read:own': ['*'],
    'create:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
  users: {
    'read:own': ['*'],
    'update:own': ['*'],
    'delete:own': ['*'],
  },
}

export default permissions
